const FormMixins = {
  data: () => ({
    alertMessage: '',
  }),

  methods: {
    async startFormProcessing() {
      this.$validator.resume();
      const result = await this.$validator.validateAll();
      if (!result) return result;
      this.errors.clear();
      this.alertMessage = '';
      return result;
    },

    clearErrors() {
      this.$validator.reset();
      this.alertMessage = '';
      this.errors.clear();
    },

    processErrors(error, formObject = null) {
      let inErrorBag = false;
      const { data } = error.response;
      if (data && typeof (data) === 'object') {
        Object.keys(data).forEach((key) => {
          if (typeof key === 'number') return;
          const origKey = Object.keys(formObject).find(k => k.toLowerCase() === key.toLowerCase());
          if (!origKey) return;
          this.errors.add({
            field: origKey,
            msg: data[key],
          });
          inErrorBag = true;
        });
      }
      if (data && !inErrorBag) {
        this.alertMessage = data;
      }
      if (!data) {
        this.alertMessage = 'An error has occurred without further information.';
      }
    },

    processOnRenderErrors(errors) {
      let inErrorBag = false;
      errors.forEach((error) => {
        console.log({ error });
        if (!error.key) {
          this.alertMessage = error.value.errors[0].errorMessage;
          inErrorBag = true;
        } else {
          this.errors.add({
            field: error.key.toLowerCase(),
            msg: error.value.errors[0].errorMessage,
          });
          inErrorBag = true;
        }

        if (!inErrorBag) {
          this.alertMessage = 'An error has occurred without further information.';
        }
      });
    },
  },
};

export default FormMixins;
